import * as API from "middleware/api";

export const frequentDestinationPre = () => API.executeWithAccessToken("/frequentdestinations.pre");

export const loadListRequestNoMock = ({ pageNumber = 1, filterText, fullList, fieldType } = {}) =>
    API.executeWithAccessToken("/frequentdestinations.list", {
        pageNumber,
        nameSearch: filterText,
        fullList,
        fieldType,
    });

// eslint-disable-next-line no-unused-vars
export const loadListRequest = ({ pageNumber = 1, filterText, fullList, fieldType } = {}) => {};

export const createDestinationPreview = (name, productType) =>
    API.executeWithAccessToken("/frequentdestinations.create.preview", {
        name,
        productType,
    });

export const createDestination = (
    number,
    idEnvironment,
    idFrequentDestination,
    localBank,
    name,
    productType,
    recipientDocumentType,
    recipientDocument,
    recipientDocumentCountry,
    recipientAddress,
    recipientName,
) =>
    API.executeWithAccessToken("/frequentdestinations.create", {
        number,
        name,
        productType,
        localBank,
        recipientName,
        idEnvironment,
        recipientDocument,
        recipientDocumentType,
        recipientDocumentCountry,
        recipientAddress,
        idFrequentDestination,
    });

export const deleteRequest = (params) =>
    API.executeWithAccessToken("/frequentdestinations.delete", {
        idFrequentDestination: params.frequentDestionationOnRow.idFrequentDestination,
    });

export const modifyFrequentDestination = (params) =>
    API.executeWithAccessToken("/frequentdestinations.modify", {
        idFrequentDestination: params.frequentDestination.idFrequentDestination,
        number: params.frequentDestination.number,
        name: params.frequentDestination.name,
        productType: params.frequentDestination.productType,
        localBank: params.frequentDestination.localBank,
        exteriorBank: params.frequentDestination.exteriorBank,
        recipientName: params.frequentDestination.recipientName,
        recipientDocument: params.frequentDestination.recipientDocument,
        recipientDocumentType: params.frequentDestination.recipientDocumentType,
        recipientDocumentCountry: params.frequentDestination.recipientDocumentCountry,
        recipientAddress: params.frequentDestination.recipientAddress,
    });
